module.exports = __webpack_public_path__ + "static/media/overlay.4a38de3b.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/login/overlay.png
// module id = 1616
// module chunks = 0